import { createContext, useContext } from 'react';

/**
 * Visual theme for a directory browse page. Products and professionals render
 * light; projects renders dark (near-black editorial background, matching the
 * project detail page). Provided by DirectoryBrowsePage and read by the shared
 * browse sections so they can flip their hardcoded colours.
 */
export type DirectoryBrowseTheme = 'light' | 'dark';

const DirectoryBrowseThemeContext =
    createContext<DirectoryBrowseTheme>('light');

export const DirectoryBrowseThemeProvider =
    DirectoryBrowseThemeContext.Provider;

export const useDirectoryBrowseTheme = (): DirectoryBrowseTheme =>
    useContext(DirectoryBrowseThemeContext);
